import React, { useState } from 'react';
import { FiX, FiSave } from 'react-icons/fi';
import '../../styles/components/_modal.scss';

/**
 * Modal para crear nueva categoría de cliente
 */
const CreateCategoryModal = ({ isOpen, onClose, onSave, isLoading = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }

    // Auto-generar código abreviado a partir del nombre
    if (name === 'name') {
      const generatedCode = value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
        .split(/\s+/) // Separar por espacios
        .filter(word => word.length > 0) // Filtrar palabras vacías
        .map(word => word.charAt(0)) // Tomar primera letra de cada palabra
        .join('') // Unir sin espacios
        .toUpperCase() // Convertir a mayúsculas
        .replace(/[^A-Z0-9]/g, '') // Solo letras y números
        .substring(0, 10); // Limitar a 10 caracteres

      setFormData(prev => ({
        ...prev,
        code: generatedCode
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es requerido';
    }

    if (!formData.code.trim()) {
      newErrors.code = 'El código es requerido';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    await onSave(formData);
    handleClose();
  };

  const handleClose = () => {
    setFormData({
      name: '',
      code: '',
      description: ''
    });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal modal--medium" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Nueva Categoría de Cliente</h2>
          <button className="modal-close" onClick={handleClose} disabled={isLoading}>
            <FiX size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-content">
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Nombre de la Categoría <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className={`form-input ${errors.name ? 'error' : ''}`}
                value={formData.name}
                onChange={handleChange}
                placeholder="Ej: Distribuidor Mayorista"
                disabled={isLoading}
                maxLength={100}
              />
              {errors.name && <span className="form-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem', display: 'block' }}>{errors.name}</span>}
            </div>

            {/* Campo código oculto - se genera automáticamente */}
            <input
              type="hidden"
              id="code"
              name="code"
              value={formData.code}
            />

            <div className="form-group">
              <label htmlFor="description" className="form-label">
                Descripción
              </label>
              <textarea
                id="description"
                name="description"
                className="form-input"
                value={formData.description}
                onChange={handleChange}
                placeholder="Descripción opcional de la categoría"
                disabled={isLoading}
                rows={3}
                maxLength={500}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-small"></span>
                  Guardando...
                </>
              ) : (
                <>
                  <FiSave size={18} />
                  Crear Categoría
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCategoryModal;
